module.exports = __webpack_public_path__ + "static/media/teamLeave.ece47195.svg";